
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/godiverse/manage-orbital-track",
      function () {
        return require("private-next-pages/godiverse/manage-orbital-track.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/godiverse/manage-orbital-track"])
      });
    }
  